import jqueryWithUI from './src/jquery.js';

export type AjaxSettings = JQuery.AjaxSettings;
export type DoneCallback = JQuery.jqXHR.DoneCallback;
export type PlainObject = JQuery.PlainObject;

export default jqueryWithUI;
